var validator = {}

validator.isAnEmail = function (value) {
	var regex = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
	
	return regex.test(value)
}
validator.isAnURL = function (value) {
	var regex = /^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/
	return regex.test(value)
}
validator.isNotEmpty = function (value) {
	return value.length > 0
}
validator.isAString = function (value) {
	var regex = /^[a-zA-Z]+$/
	return regex.test(value)
}
validator.isAnInteger = function (value) {
	var regex = /^\d+$/
	return regex.test(value)
}
validator.isAPhoneNumber = function (value) {
	var regex = /^[0-9+\(\)#\.\s\/ext-]+$/
	return regex.test(value)
}

// is for dd/mm/yyyy and dd-mm-yyyy and dd.mm.yyyy
validator.isDate = function (value) {
	var regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/
	return regex.test(value)
}
validator.passwordRules = function (value) {
	var regex = /^(?=[^0-9])(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])[a-zA-Z0-9]{8,}$/

	if (regex.test(value)) {
	// can not begin with a digit & can not contain / or @
		var newRules = /^\d+/
		return !newRules.test(value)
	} else {
		return false
	}
}

module.exports = validator



// WEBPACK FOOTER //
// ./lib/validator.js